module.exports = __webpack_public_path__ + "img/bsia.bdabd8fa.png";